import { Injectable } from '@angular/core';
import config from '../config';

@Injectable({
  providedIn: 'root'
})
export class AccessLogService {
  private endpoint = config.API_VIDEO_SERVER;

  constructor() {
    const host = window.location.host;
    if (['localhost', 'pre.video.videoconsulta.io'].some(e => host.includes(e))) {
      this.endpoint = config.API_VIDEO_SERVER_PRE;
    }
  }

  logAccess(sess: string): Promise<Response> {
    return fetch(`${this.endpoint}/participants/${sess}/logAccess`, {
      method: 'POST',
    });
  }
}
